import type { StoreRecord } from '@/services/storeService'

/** Wallet rows are per (store, currency); align UI with the store’s trading currency. */
export function effectiveWalletCurrency(store: StoreRecord | undefined): string | undefined {
  if (!store) return undefined
  const c = store.currency?.trim() || store.organisation?.currency?.trim()
  if (!c) return undefined
  return c.toUpperCase()
}
